
import AppCustomLanguageSelect from "@/components/CustomLanguageSelect.vue";
import AppStyleEditor from "@/components/layout-editor/StyleEditor.vue";
import { TranslatedStyledProperty } from "@/utils/documents/translated-styled-property";
import Vue from "vue";
export default Vue.extend({
	data() {
		return {
			lang: "",
			editStyle: false
		};
	},
	props: {
		lines: Object as () => TranslatedStyledProperty
	},
	components: {
		AppCustomLanguageSelect,
		AppStyleEditor
	},
	i18nEx: {
		componentPrefix: "components.reminder-layout-editor"
	}
});
